import { useSelector } from 'react-redux';
import { useShopPromotionBannerDetails } from '../components/ShopPromotionBanner';
import { showNanoVariant } from '../components/NanoBanner/NanoBanner';
import { useLocale } from '../contexts/LocaleContext';
import { getFiGrowthBook } from '../lib/growthbook';
import { getQuizReferral, isQuizBannerDismissed } from '../lib/quizReferral';
import { getNanoReferralPetNameCookie } from '../lib/util/nanoReferralPetNameCookie';
import { AppState } from '../types';

/**
 * The live promotion's coupon code as an offer the shopper has not taken yet, for surfaces that
 * quote it next to a price (the shop cards, the bag's one-tap apply). Undefined once any code is on
 * the cart, so a price never carries a second code beside it, and wherever the banner itself would
 * not make the offer: unsupported country, referral session, or a session the quiz or nano banner
 * has claimed with a different code.
 */
export default function useShopPromotionOffer(): string | undefined {
  const { country } = useLocale();
  const { couponCode, showPromotion } = useShopPromotionBannerDetails();
  const cart = useSelector((state: AppState) => state.storeShop.cart);

  const supportedCountries = getFiGrowthBook().getFeatureValue<string[]>('ecom-promo-banner-supported-countries', [
    'US',
    'CA',
    'GB',
  ]);
  const claimedByAnotherBanner =
    showNanoVariant() || !!getNanoReferralPetNameCookie() || (!!getQuizReferral() && !isQuizBannerDismissed());

  if (
    !showPromotion ||
    !couponCode ||
    !supportedCountries.includes(country) ||
    cart.couponCode ||
    cart.referralCode ||
    claimedByAnotherBanner
  ) {
    return undefined;
  }
  return couponCode;
}
